import { render, staticRenderFns } from "./language-experiment-info.vue?vue&type=template&id=37b7f52e&scoped=true&"
import script from "./language-experiment-info.vue?vue&type=script&lang=js&"
export * from "./language-experiment-info.vue?vue&type=script&lang=js&"
import style0 from "./language-experiment-info.vue?vue&type=style&index=0&id=37b7f52e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b7f52e",
  null
  
)

export default component.exports